import React from 'react';
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import cl from "./SurveysItemForm.module.css";
import CheckedCheckboxIcon from "../../components/Icons/CheckedCheckboxIcon";
import EmptyCheckboxIcon from "../../components/Icons/EmptyCheckboxIcon";
import SurveyBlock from "./SurveyBlock";

const SurveysItemForm = ({surveyData, initData, controlRef, summaryMode}) => {

    function renderSurveyStep(step) {
        return <div className={cl.stepBlock} key={step.id}>
            <p className={cl.stepTitle}>{step.position}. {step.title}</p>
            <div className={cl.stepBody}>
                {step.options.map(x => renderStepOption(step, x))}
                {step.type === "custom" && renderCustomStepOption(step)}
            </div>
        </div>
    }

    function renderStepOption(step, option) {
        const answer = summaryMode ? initData.steps.find(x => x.step_id === step.id)?.options.find(x => x.option_id === option.id) : initData.answers.find(x => x.option_id === option.id);
        const isSelected = summaryMode ? answer?.count !== undefined && answer.count !== 0 : Boolean(answer);

        return renderStepOptionHelper(option.id, isSelected, option.title, answer?.custom_text, answer?.count);
    }

    function renderCustomStepOption(step) {
        const answer = summaryMode ? initData.steps.find(x => x.step_id === step.id) : initData.answers.find(x => x.step_id === step.id);
        const isSelected = summaryMode ? answer?.answers_count !== undefined && answer.answers_count !== 0 : Boolean(answer);

        return renderStepOptionHelper(-1, isSelected, "(напишите)", answer?.custom_text, answer?.answers_count);
    }

    return (
        <BaseSimpleItemEditorForm>
            {!summaryMode && <SurveyBlock
                initData={initData}
            />}
            <FormBlock>
                <div className={cl.stepBlockContainer}>
                    {surveyData.steps.map(renderSurveyStep)}
                </div>
            </FormBlock>
        </BaseSimpleItemEditorForm>
    );
};

function renderStepOptionHelper(key, isSelected, optionTitle, customText, summaryCount) {
    const summaryMode = summaryCount !== undefined;
    return <div key={key} className={cl.stepBodyOption}>
        <div className={summaryMode ? cl.stepBodyOptionSummaryStatus : cl.stepBodyOptionStatus}>
            {summaryMode && <div className={cl.summaryCount}>&nbsp;{summaryCount > 0 ? summaryCount : ""}</div>}
            {!summaryMode && (isSelected ? <CheckedCheckboxIcon fgColor={"#000"}/> : <EmptyCheckboxIcon fgColor={"#444"}/>)}
        </div>
        <div className={`${cl.stepBodyOptionValue} ${isSelected ? cl.selected : ""}`}>
            <p>{optionTitle}</p>
            {!summaryMode && customText && <p className={cl.customText}>{customText}</p>}
        </div>
    </div>
}

export default SurveysItemForm;